module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("成员信息")])]), _vm._v(" "), (_vm.memberDetail && _vm.memberDetail.memberName) ? _c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.memberName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.mobile))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.email))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.firstLevelEnterpriseName))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("加入日期")]), _vm._v(" "), _c('span', {
    staticClass: "attr"
  }, [_vm._v(_vm._s(_vm.memberDetail.createDT.split(" ")[0]))])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [(_vm.memberDetail && _vm.memberDetail.memberName) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("审批原则")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }, [(_vm.approve.approveType === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批原则")]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeNone) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#60d837"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeAll) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#ff9400"
    }
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.approve.approveType]))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单笔订单限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }, [(_vm.approve.approveThreshold === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.approveThreshold === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.approveThreshold))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.approve.approveType === _vm.approveTypeThreshold) ? _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单月累积限额")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype",
    on: {
      "click": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }, [(_vm.approve.monthlyLimit === undefined) ? _c('span', {
    staticClass: "attr",
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("请设置审批限额")]) : (_vm.approve.monthlyLimit === '') ? _c('span', {
    staticClass: "attr unlimitedAmount"
  }, [_vm._v("无限额")]) : _c('span', {
    staticClass: "price"
  }, [_vm._v("¥" + _vm._s(_vm.approve.monthlyLimit))]), _vm._v(" "), _c('svg', {
    staticClass: "liveiconput",
    attrs: {
      "t": "1583809028111",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1461",
      "width": "200",
      "height": "200"
    }
  }, [_c('path', {
    attrs: {
      "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
      "fill": "#929292",
      "p-id": "1462"
    }
  })])])]), _vm._v(" "), _vm._m(7)]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.type === _vm.emkt.RESEARCH_MEMBER_OP.add) ? _c('div', {
    staticClass: "ft",
    on: {
      "click": function($event) {
        return _vm.checkMember()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("删除成员")])]) : _vm._e(), _vm._v(" "), (_vm.type === _vm.emkt.RESEARCH_MEMBER_OP.approval) ? _c('div', {
    staticClass: "ft submitAddMember",
    on: {
      "click": function($event) {
        return _vm.submitAddMember()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认添加")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showChooseApproveType) ? _c('ChooseApproveType1', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setallApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglestrokeApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setSinglestrokeApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showChooSinglemouthApproveType) ? _c('ChooseApproveType2', {
    attrs: {
      "memberDetail": _vm.memberDetail,
      "setApproveType": _vm.setmouthApproveType
    },
    on: {
      "updateMemberApproveType": _vm.saveApproveType,
      "toggleShow": function($event) {
        return _vm.toggleShowChooseBox(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox,
      "confirm": _vm.deleteMember
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3820d34e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberDetail.vue
// module id = 1600
// module chunks = 8